module.exports = __webpack_public_path__ + "static/media/i29.5b87a226.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/i29.svg
// module id = 187
// module chunks = 12